import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../Bem/Bem';
import { confirm } from '../Confirm/Confirm';

import './ConfirmPayAction.css';
import * as keyset from './ConfirmPayAction.i18n';

const i18n = i18nFactory(keyset);

export interface PayActionCampaign {
    id: string;
    name: string;
}

export function confirmPayAction(
    campaigns: PayActionCampaign[]
): Promise<void> {
    return confirm({
        message: i18n('pay-will-not-apply-for-campaigns'),
        children: (
            <div className={Bem.cls('confirm-pay-action')}>
                {campaigns.map(el => (
                    <div className={Bem.cls('confirm-pay-action', 'item')}>
                        {el.name} (№ {el.id})
                    </div>
                ))}
                <div className={Bem.cls('confirm-pay-action', 'item')}>
                    {i18n('continue')}
                </div>
            </div>
        )
    });
}
